module.exports = __webpack_public_path__ + "img/search_icon.14e8ed87.svg";